import { PROGRESS_CANCEL, PROGRESS_DID_CANCEL } from './actions';
import { Action } from 'redux';

export const progressReducer = (
  state = { cancelled: false },
  action: Action<typeof PROGRESS_CANCEL | typeof PROGRESS_DID_CANCEL>,
) => {
  // Assumes only one progress request can occur at a time, hence cancelled applies globally
  switch (action.type) {
    case PROGRESS_CANCEL:
      return { cancelled: true };
    case PROGRESS_DID_CANCEL:
      return { cancelled: false };
    default:
      return state;
  }
};
